import articleInfoTransformer from "./articleInfo";
import bylineTransformer from "./byline";
import featuredImageTransformer from './featuredImage';
import titleTransformer from './title';
import { sanitizeBreadcrumbs } from "../../../utilities/breadcrumbs";

const pageHeaderPropsTransformer = (queried) =>
{
    const articleInfo = queried?.post?.author ? articleInfoTransformer(queried) : false;
    const byline = bylineTransformer(queried);
    const featuredImage = featuredImageTransformer(queried);
    const title = titleTransformer(queried);

    const breadcrumbs = sanitizeBreadcrumbs(queried?.post?.cdmfields?.breadcrumb);
    return {
        breadcrumbs,
        articleInfo,
        byline,
        featuredImage,
        title
    }
}
export default pageHeaderPropsTransformer;